/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {InfoIcon} from '@ion/dls/src/icons/InfoIcon';

/**
 * Defines the `SearchFieldDefaultTooltip` Prop types definitions. The `title`
 * prop which is used by all Search Copy / Paste tooltips is to be provided
 * as a prop via the parent component.
 */
export interface SearchFieldDefaultTooltipProps {
  title: string;
}

/**
 * @internal
 *
 * The `SearchFieldDefaultTooltip` provides the default Tooltip implementation for
 * Modular Search Fields. This component is used internally and generally not exposed
 * to clients.
 */
const SearchFieldDefaultTooltip = ({title}: SearchFieldDefaultTooltipProps) => (
  <Tooltip arrow title={title}>
    <span>
      <InfoIcon />
    </span>
  </Tooltip>
);
export default React.memo(SearchFieldDefaultTooltip);
